import Vue from 'vue';
import router from './router';
import DEFINES from '@/defines'
import VueAnalytics from 'vue-analytics';

const analytics = () => {
    if(DEFINES.NODE_ENV === 'production'){
        return Vue.use(VueAnalytics, {
            id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
            router
        });
    }
}

export default analytics()
